import { render } from "./OutOfProductionNav.vue?vue&type=template&id=9fb2b9ba&ts=true"
import script from "./OutOfProductionNav.vue?vue&type=script&lang=ts"
export * from "./OutOfProductionNav.vue?vue&type=script&lang=ts"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__